// extracted by mini-css-extract-plugin
var _1 = "ExtensionTopicBar-module__container--ULvxq";
var _2 = "ExtensionTopicBar-module__topicContainer--gtYZ1";
export { _1 as "container", _2 as "topicContainer" }
